<script>
import VuePdfApp from "vue-pdf-app";

export default {
  name: "loginByToken",
  data(){
    return{

    }
  },
  created() {
    let token = this.getQueryString('token');
    let path = this.getQueryString('path');
    sessionStorage.setItem("token",token);
          this.$router.push({
            //path: "/study/history",
            path: path,
          });
  },
  methods:{
    getQueryString(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      let r = window.location.href.substring(window.location.href.indexOf("?")+1).match(reg);
      if (r != null) {
        return decodeURIComponent(r[2]);
      };
      return null;
    }
  }
}
</script>

<template>

</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/redirect/loginByToken.vue